import * as React from 'react';
import { SVGProps } from 'react';
export const Warn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden={true}
    focusable={false}
    {...props}
  >
    <path
      d="M11.998 8.335v5.428m-9.78 4.48 8.1-15.235A1.897 1.897 0 0 1 12 2a1.91 1.91 0 0 1 1.682 1.008l8.1 15.236a1.874 1.874 0 0 1-.751 2.518c-.285.158-.607.24-.933.238h-16.2a1.898 1.898 0 0 1-1.624-.905 1.874 1.874 0 0 1-.057-1.851Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor" />
  </svg>
);
